export default __webpack_public_path__ + "static/media/004-bicycle.62d8a45f.svg";